import { FeatureFlagRule } from './types';

export const booleanStringRule: FeatureFlagRule = (value) => {
  return value === '1' || value === 'true' || value === true;
};

export const defaultRule: FeatureFlagRule = (value) => {
  return value === 'true' || value === '1' || value === true;
};
